import React, { FC } from 'react';

import useChargesKMLN from '../services/useGetChargesKM';
import ChargesLNScene from './charges-ln-scene';

interface Props {
  showHeaderAndContainer?: boolean;
}

const ChargesLN: FC<Props> = ({ showHeaderAndContainer = true }) => {
  const {
    dataCharges,
    handleDelete,
    handleEditModal,
    openAddModal,
    handleAddModal,
    reloadAccounting,
    state,
  } = useChargesKMLN(['L', 'N']);
  return (
    <ChargesLNScene
      accountingData={dataCharges || []}
      handleDelete={handleDelete}
      handleEditModal={handleEditModal}
      openAddModal={openAddModal}
      handleaddModal={handleAddModal}
      reloadAccounting={reloadAccounting}
      state={state as any}
      showHeaderAndContainer={showHeaderAndContainer}
    />
  );
};

export default ChargesLN;
